<div class="flex flex-row items-center search-container">
  <mat-icon class="ml-16 icon-md icon-color cursor-pointer" [svgIcon]="'search'" (click)="clearInput()"></mat-icon>
  <input (keyup)="onKeyUp($event)" class="fw-400 h-34 no-border" placeholder="{{ placeholder | transloco }}"
         type="text" value="{{searchText}}" #searchInput>
  <mat-icon *ngIf="searchText?.length > 0" class="ml-12 mr-16 icon-md icon-color cursor-pointer" [svgIcon]="'close'" (click)="clearInput()"></mat-icon>
</div>
